import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import ProfileContent from "../components/ProfileContent";
import Header from '../components/common/Header';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { validateLogin } from '../services/validate-login';

export default function Profile() {
  const navigate = useNavigate();

  useEffect(() => {
    validateLogin(navigate);
  }, []);
  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
      <div className="min-h-full">
        <Header title="Dashboard"/>
        <header className="bg-white shadow">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">Profile</h1>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <ProfileContent />
          </div>
        </main>
      </div>
    </>
  )
}
